import { t } from 'i18next';
import { ResourcesCard, type ResourcesCardItem } from '../../../components/resources-card';

function getItems(): ReadonlyArray<ResourcesCardItem> {
  return [
    {
      icon: 'priceList',
      title: t('price_lists.resources_card.quantity_pricing.title'),
      subtitle: t('price_lists.resources_card.quantity_pricing.subtitle'),
      onClick: () => window.open('https://docs.sparklayer.io/quantity-pricing', '_blank'),
    },
    {
      icon: 'cube',
      title: t('price_lists.resources_card.pack_size_rules.title'),
      subtitle: t('price_lists.resources_card.pack_size_rules.subtitle'),
      onClick: () => window.open('https://docs.sparklayer.io/quantity-rules', '_blank'),
    },
    {
      icon: 'calculator',
      title: t('price_lists.resources_card.unit_of_measure.title'),
      subtitle: t('price_lists.resources_card.unit_of_measure.subtitle'),
      onClick: () =>
        window.open(
          'https://docs.sparklayer.io/quantity-pricing#unit-of-measure-pricing',
          '_blank',
        ),
    },
  ];
}

export function PriceListsResourcesCard() {
  return <ResourcesCard title={t('price_lists.resources_card.header')} items={getItems()} />;
}
